// Copyright © Aptos Foundation
// SPDX-License-Identifier: Apache-2.0

/**
 * The current version of the SDK
 *
 * hardcoded for now, we would want to have it injected dynamically
 */
export const VERSION = "1.16.0";
